import React, { useState, useEffect } from "react";
import { securityFilter } from "../../../../../utils/securityFilter";
import { isSpecialCharContains } from "../../../../../utils/specialCharCheck";
import validator from "validator";
import {
  editAccDetails,
  getAccountDetails,
  deleteUserAccount,
  changeAccPwd,
} from "../../../AxiosRtk/Settings";
import { setUser } from "../../../AxiosRtk/Auth";
import { AlertModal } from "../../../../../setup/alert/swalAlert";
import { alertIconType } from "../../../../../setup/alert/iconTypes";
import SettingDeleteAccount from "../../modals/SettingDeleteAccout";
import DeletedSuccessfully from "../../modals/DeletedSuccessfully";
import useAuthentication from "../../../../customHooks/authentication";
import { useSelector, useDispatch } from "react-redux";
import { getter, setter } from "../../../../../utils/storage";
import ModifyPassword from "../../modals/ModifyPassword";
import {
  setShowEmailVerification,
  setShowMessage,
} from "../../../AxiosRtk/successMessage";
import Select from "react-select";
import useCrypto from "../../../../customHooks/crypto";
// import useLangTranslation from "../../../../customHooks/languageProvider";

const AccountSettings = ({
  countryList,
  timezoneIdList,
  getLangTranslation,
  checkSubsciption,
}) => {
  const dispatch = useDispatch();
  const { encryptRequest, decryptRequest } = useCrypto();
  const [showModal, setShowModal] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(true);
  // const { getLangTranslation } = useLangTranslation();

  const openModal = () => {
    if (!checkSubsciption()) {
      return;
    }
    setShowModal(true);
  };
  const closeModal = () => {
    setShowModal(false);
  };
  const [showDeletedModal, setShowDeletedModal] = useState(false);
  const [load, setLoad] = useState(false);
  const { handleLogout } = useAuthentication();
  const { isAdditionalParent, user } = useSelector(({ auth }) => auth);
  const [countryOptions, setCountryOptions] = useState([]);
  const [timeZoneOptions, setTimeZoneOptions] = useState([]);
  const [input, setInput] = useState({
    name: { value: "", error: "", errValue: "" },
    email: { value: "", error: "", errValue: "" },
    contact: { value: "", error: "", errValue: "" },
    country: { value: "", error: "", errValue: "" },
    timezone: { value: "", error: "", errValue: "" },
  });

  const [displayType, setDisplayType] = useState({
    oldPwd: "password",
    newPwd: "password",
  });
  const [pwdModifyModal, setPwdModifyModal] = useState(false);
  const [pwd, setPwd] = useState({
    current: { value: "", error: "" },
    newPwd: { value: "", error: "" },
    confirmNewPwd: { value: "", error: "" },
  });

  useEffect(() => {
    getAccountDetails()
      .then((res) => {
        const data = res?.data?.result[0];
        setInput({
          name: { value: data?.FullName, error: "" },
          email: { value: data?.Email, error: "" },
          contact: { value: data?.phone_no, error: "" },
          country: { value: data?.countryCode, error: "" },
          timezone: { value: data?.UserTimezoneID, error: "" },
        });
        setIsEmailVerified(data?.isEmailVerification == 1 ? true : false);
      })
      .catch((error) => {
        console.log(
          "get acc details catch error ==>>",
          error?.response?.data?.message
        );
      });
  }, []);


  function handleChange(e) {
    const { name, value } = e.target;
    if (name === "name") {
      if (value && !securityFilter(value)) {
        setInput({
          ...input,
          value: input?.name?.value,
          error: "SPECIAL_CHAR_NOT_ALLOWED_ERR",
          errValue: "Special characters are not allowed",
        });
      } else if (value && isSpecialCharContains(value)) {
        setInput({
          ...input,
          value: input?.name?.value,
          error: "SPECIAL_CHAR_NOT_ALLOWED_ERR",
          errValue: "Special characters are not allowed",
        });
      } else {
        setInput({
          ...input,
          name: {
            value,
            error: "",
          },
        });
      }
    } else if (name === "email") {
      if (value && !validator.isEmail(value)) {
        setInput({
          ...input,
          email: {
            value,
            error: "EMAIL_FORMAT_NOT_VALID_ERR",
            errValue: "Email format is not valid",
          },
        });
      } else {
        setInput({
          ...input,
          email: {
            value,
            error: "",
          },
        });
      }
    } else if (name === "contact") {
      if (value && value?.length > 30) {
        setInput({
          ...input,
          contact: {
            value: input?.contact?.value,
            error: getLangTranslation(
              "ONLY_30_DIGITS_ALLOWED",
              "Only 30 digits allowed."
            )
          },
        });
      } else if (value && isNaN(value)) {
        setInput({
          ...input,
          contact: {
            value: input?.contact?.value,
            error: getLangTranslation(
              "ONLY_NUM_ALLOWED",
              "Only number allowed."
            )
          },
        });
      } else {
        setInput({
          ...input,
          contact: {
            value,
            error: "",
          },
        });
      }
    } else if (name === "old_password") {
      setPwd({
        ...pwd,
        old_password: {
          value,
          error: "",
        },
      });
    } else if (name === "password") {
      setPwd({
        ...pwd,
        password: {
          value,
          error: "",
        },
      });
    } else if (name === "country") {
      setInput({
        ...input,
        country: {
          value,
          error: "",
        },
      });
    } else if (name === "timezone") {
      setInput({
        ...input,
        timezone: {
          value,
          error: "",
        },
      });
    }
  }

  useEffect(() => {
    setCountryOptions(
      countryList?.map((item) => {
        return { value: item?.CountryID, label: item?.CountryName };
      })
    );
  }, [countryList]);

  useEffect(() => {
    setTimeZoneOptions(
      timezoneIdList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [timezoneIdList]);

  function handleSaveBtn() {
    if (!checkSubsciption()) {
      return;
    }
    const { name, email, contact, country, timezone } = input;
    const payload = {};
    const changePwdPayload = {};

    const tempUser = { ...user };

    if (name?.value) {
      payload["FullName"] = name?.value;
      tempUser["FullName"] = name?.value;
      tempUser["name"] = name?.value;
    }

    if (
      email?.value &&
      email?.value?.toLowerCase() !== user?.Email?.toLowerCase()
    ) {
      payload["Email"] = email?.value;
      tempUser["Email"] = email?.value;
    }

    if (contact?.value) {
      payload["phone_no"] = contact?.value;
      tempUser["phone_no"] = contact?.value;
    }

    if (pwd?.current?.value && pwd?.newPwd?.value) {
      changePwdPayload["oldPassword"] = pwd?.current?.value;
      changePwdPayload["newPassword"] = pwd?.newPwd?.value;
    }

    if (country?.value) {
      payload["countryCode"] = country?.value?.toString();
      tempUser["country"] = country?.value?.toString();
    }

    if (timezone?.value) {
      payload["UserTimezoneID"] = timezone?.value?.toString();
      tempUser["UserTimezoneID"] = timezone?.value?.toString();
    }

    const detailUpldate = {
      payloadValue: Object.keys(payload)?.length > 0,
      res: false,
    };

    const pwdDetailUpdate = {
      payloadValue: Object.keys(changePwdPayload)?.length > 0,
      res: false,
    };

    if (detailUpldate.payloadValue) {
      editAccDetails(payload)
        .then((res) => {
          dispatch(setUser(tempUser));
          setter("kidoProtectUser", encryptRequest(JSON.stringify(tempUser)).content);

          if (pwdDetailUpdate.payloadValue) {
            changeAccPwd(changePwdPayload)
              .then((res) => {
                pwdDetailUpdate["res"] = true;
                dispatch(
                  setShowMessage({
                    showMessage: true,
                    defaultMessage: "Details have been updated",
                    message: "DETAILS_UPDATE",
                  })
                );
                setTimeout(() => {
                  handleLogout();
                }, 3000);
              })
              .catch((err) => {
                AlertModal(
                  getLangTranslation(err?.response?.data?.message),
                  alertIconType?.errorIcon,
                  true
                );
              });
          } else {
            {
              /*     AlertModal(
              getLangTranslation("DETAILS_UPDATE", "Details have been updated"),
              alertIconType?.successIcon
       );*/
            }
            dispatch(
              setShowMessage({
                showMessage: true,
                defaultMessage: "Details have been updated",
                message: "DETAILS_UPDATE",
              })
            );
          }
        })
        .catch((err) => {
          AlertModal(
            getLangTranslation(err?.response?.data?.message),
            alertIconType?.errorIcon,
            true
          );
        });
    }
  }

  function openDeletedModal() {
    setShowDeletedModal(true);
  }

  function closeDeletedModal() {
    setShowDeletedModal(false);
    handleLogout();
  }

  function handleDelete() {
    const payload = {
      reason: "test",
      comment: "test",
    };

    setLoad(true);
    deleteUserAccount(payload)
      .then((res) => {
        openDeletedModal();
        closeModal();
      })
      .catch((err) => {
        console.log(
          "edit acc details catch error ====>>>",
          err?.response?.data?.message
        );
      })
      .finally(() => {
        setLoad(false);
      });
  }

  return (
    <>
      <div className="content-550 mx-auto">
        <h5 className="my-6 text-capitalize">
          {getLangTranslation(
            "SETTINGS_DELETE_MY_ACCOUNT",
            "Delete my account"
          )?.replace("Delete ", "")}
        </h5>
        <div className="mb-6">
          <label htmlFor="fullName" className="form-label">
            {getLangTranslation(
              "ACCOUNT_SETTINGS_PARENT_FULL_NAME",
              "Full name"
            )}
          </label>
          <input
            type="text"
            className="form-control"
            id="fullName"
            name="name"
            placeholder={getLangTranslation(
              "ACCOUNT_SETTINGS_PARENT_FULL_NAME",
              "Full name"
            )}
            value={input?.name?.value}
            onChange={handleChange}
          />
          {input?.name?.error && (
            <label className="field-error">
              {getLangTranslation(input?.name?.error)}
            </label>
          )}
        </div>
        <div className="mb-6">
          <label htmlFor="emailId" className="form-label">
            {getLangTranslation("EMAIL", "Email")}
          </label>
          <input
            type="email"
            className="form-control"
            id="emailId"
            placeholder={getLangTranslation("EMAIL", "Email")}
            name="email"
            value={input?.email?.value}
            // onChange={handleChange}
            disabled={true}
          />
          {input?.email?.error && (
            <label className="field-error">
              {getLangTranslation(input?.email?.error)}
            </label>
          )}
          {!isEmailVerified && (
            <label className="field-error">
              {getLangTranslation(
                "EMAIL_NOT_YET_VERIFIED",
                "Email is not yet verified."
              )}{" "}
              {/* Email is not yet verified.&nbsp; */}
              <u
                className="cursor-pointer"
                onClick={() => {
                  dispatch(setShowEmailVerification(true));
                }}
              >
                {getLangTranslation(
                  "CLICK_TO_VERIFY_YOUR_EMAIL",
                  "Click to verify your email"
                )}{" "}
              </u>
              {getLangTranslation("ADDRESS", "address")}
            </label>
          )}
        </div>
        <div className="mb-6">
          <label htmlFor="contact" className="form-label">
            {getLangTranslation("PHONE_NUMBER", "Phone number")}
          </label>
          <input
            type="text"
            className="form-control"
            id="contact"
            name="contact"
            placeholder={getLangTranslation("PHONE_NUMBER", "Phone number")}
            value={input?.contact?.value}
            onChange={handleChange}
          />
          {input?.contact?.error && (
            <label className="field-error">
              {getLangTranslation(input?.contact?.error)}
            </label>
          )}
        </div>

        <div className="mb-3">
          <label htmlFor="Password" className="form-label">
            {getLangTranslation("LOGIN_CHILD_PASSWORD", "Password")}
          </label>
          <div className="input-group ">
            <input
              type={displayType?.newPwd}
              className="form-control border-end-0"
              id="Password"
              name="password"
              placeholder={getLangTranslation(
                "LOGIN_CHILD_PASSWORD",
                "Password"
              )}
              value="********"
              readOnly={true}
              // onChange={handleChange}
              onClick={() => setPwdModifyModal(true)}
            />
          </div>
          {input?.password?.error && (
            <label className="field-error">
              {getLangTranslation(input?.password?.error)}
            </label>
          )}
        </div>
        <div className="mb-6">
          <label htmlFor="Country" className="form-label">
            {getLangTranslation("SIGNUP_COUNTRY", "Country")}
          </label>

          <Select
            className="custom-select "
            classNamePrefix="custom-select"
            placeholder="Select Country"
            options={countryOptions}
            value={
              countryOptions?.find(
                (item) =>
                  parseInt(item?.value) === parseInt(input?.country?.value)
              ) || ""
            }
            onChange={(val) => {
              setInput({
                ...input,
                country: {
                  value: val.value,
                  error: "",
                },
              });
            }}
            isSearchable={true}
          />
        </div>
        <div className="mb-6">
          <label htmlFor="TimeZone" className="form-label">
            {getLangTranslation("TIME_ZONE", "Time Zone")}
          </label>

          <Select
            className="custom-select "
            classNamePrefix="custom-select"
            placeholder="Select Timezone"
            options={timeZoneOptions}
            value={
              timeZoneOptions?.find(
                (item) =>
                  parseInt(item?.value) === parseInt(input?.timezone?.value)
              ) || ""
            }
            onChange={(val) => {
              setInput({
                ...input,
                timezone: {
                  value: val.value,
                  error: "",
                },
              });
            }}
            isSearchable={true}
          />
        </div>
        {!isAdditionalParent && (
          <span
            className="text-danger d-inline-flex align-items-center mb-6 pt-cursor gap-2"
            onClick={openModal}
          >
            <i className="icon-trash fs-4" />
            <span className="text-small">
              {getLangTranslation(
                "SETTINGS_DELETE_MY_ACCOUNT",
                "Delete my account"
              )}
            </span>
          </span>
        )}

        <button
          className="btn btn-primary w-100"
          type="button"
          onClick={handleSaveBtn}
        >
          <span className="btn-upper-case">
            {getLangTranslation("SAVE", "Save")}
          </span>
        </button>
      </div>
      {/* <DeleteAccount showModal={showModal} closeModal={closeModal} /> */}
      <SettingDeleteAccount
        showModal={showModal}
        closeModal={closeModal}
        getLangTranslation={getLangTranslation}
        handleDelete={handleDelete}
        load={load}
      />
      <DeletedSuccessfully
        showDeletedModal={showDeletedModal}
        closeDeletedModal={closeDeletedModal}
        getLangTranslation={getLangTranslation}
      />
      <ModifyPassword
        pwdModifyModal={pwdModifyModal}
        setPwdModifyModal={setPwdModifyModal}
        getLangTranslation={getLangTranslation}
        pwd={pwd}
        setPwd={setPwd}
      />
    </>
  );
};

export default AccountSettings;
